export default {
  common: {
    esg: {
      category: '類別',
      environment: '環境',
      society: '社會',
      governance: '治理',
      other: '其他',
      comprehensive: '綜合',
      // basic: '',
    },
    btn: {
      cancel: '取消',
      add: '追加',
      create: '建立',
      update: '更新',
      apply: '應用',
      close: '關閉',
      create_new: '新增',
      edit: '編輯',
      detail: '詳細內容',
      view_detail: '詳細內容',
      delete: '刪除',
      change: '切換',
      confirm: '確認',
      clear: '清除條件（重設條件）',
      download: '下載',
      save: '儲存',
      register: '登錄',
      check_answer: '確認回答',
      score_card_list: '評分卡一覽表',
      confirm_action: '@:common.btn.confirm',
      edit_action: '@:common.btn.edit',
      create_action: '@:common.btn.create',
      add_action: '@:common.btn.add',
      bulk_download: '整批下載',
    },
    link: {
      delete: '刪除',
      back: '返回',
    },
    sentence: {
      back_to_login: '返回登入',
      back_to_dashboard: '返回數據儀表板',
      not_applicable: '非適用對象※',
      // back_to_top: '',
    },
    switch: {
      current_language: 'Language',
    },
    filter: {
      questionnaire: '問卷',
      questionnaire_short: '@:common.filter.questionnaire',
      target_questionnaire: '請選擇對象問卷',
      target_year: '對象年度',
      target_year_text: '請選擇對象年度。',
      target_company: '對象公司',
      target_company_text: '請選擇對象公司。',
      total: '全部{total}筆',
    },
    label: {
      required: '必須',
      optional: '任意',
      year: '年度',
    },
    form: {
      search_word: {
        label: '關鍵字搜尋',
        placeholder: '@:common.placeholder.input_free',
      },
    },
    date: {
      dateFormatTemp: 'dd/MM/yyyy',
      dateTimeFormatTemp: 'dd/MM/yyyy HH:mm zzz',
      datePickerFormat: 'dd/MM/yyyy',
      datePickerPlaceholder: 'DD/MM/YYYY',
      issue_date: '發行日',
      evaluation_expires_date: '有效期限',
      answer_expires_date: '回答期限',
      // last_updated_date: '',
    },
    error: {
      code_0005: '驗證失敗。請重新登入。',
      code_0007: '為必填項目。',
      code_5001: '未發現頁面。',
      code_0001: '已提交最新的問題。',
      code_0002: '資料已從其他終端機更新，無法更新。請重新讀取後操作重新執行。',
      code_0003: '無法刪除檔案。請至少回答1個問題後再刪除。',
      code_0006: '已登錄的使用者。',
      code_0004: '檔案大小超過可上傳的大小。1個檔案最大為50MB。',
      code_9999: '發生意外錯誤。',
    },
    evaluation: {
      title: '委託評估',
      dashboard: '數據儀表板',
      analysis: '分析',
      list: '企業一覽表',
    },
    dashboard: {
      title: '數據儀表板',
    },
    upload: {
      title: '問卷',
      common: '通用',
    },
    scorecard: {
      title: '評分卡',
      list: '一覽表',
      detail: '詳細內容',
      scorecard_detail: '評分卡詳細內容',
      answer_preview: '預覽回答',
      // breadcrumb_detail: '',
    },
    improvementplans: {
      title: '改善計畫',
      detail: '@:common.scorecard.detail',
      // breadcrumb_detail: '',
    },
    detailExtra: {
      title: '應用分析',
    },
    settings: {
      title: '設定',
    },
    // default_selector: {
    //   selected_label: '',
    //   do_select:      '',
    //   do_release:     '',
    // },
    contact: {
      title: '常見提問',
    },
    logout: {
      title: '登出',
    },
    industry: {
      type_1: '農林水產業',
      type_2: '礦業、採石業、砂石開採業',
      type_3: '建設業（包括設備工程業）',
      type_4: '製造業（鋼鐵、非鐵金屬、金屬產品）',
      type_5: '製造業（機械器具、電子設備等）',
      type_6: '製造業（食品、飲料、菸草等）',
      type_7: '製造業（紙漿、紙、紙加工品）',
      type_8: '製造業（木材、木製品等加工）',
      type_9: '製造業（化學工業（包括醫藥品）、纖維工業）',
      type_10: '製造業（石油、煤炭、橡膠、塑膠等）',
      type_11: '製造業（印刷業）)',
      type_12: '製造業（其他）',
      type_13: '電力、天然氣、熱供應',
      type_14: '資訊通訊',
      type_15: '運輸業、倉庫業',
      type_16: '批發業、零售業',
      type_17: '金融業、保險業',
      type_18: '不動產業',
      type_19: '學校（包括幼稚園、幼兒園等）',
      type_20: '住宿業、餐飲服務業',
      type_21: '生活相關服務業（洗衣、理容、美容、洗浴業等）',
      type_22: '醫療、社會福利',
      type_23: '廢棄物處理業、資源回收業',
      type_24: '汽車維修業',
      type_25: '地方政府、行政機關等',
      type_26: '其他',
    },
    scale: {
      a: '1〜29 人',
      b: '30〜99 人',
      c: '100〜499 人',
      d: '500〜999 人',
      e: '1000〜4999 人',
      f: '5000人〜',
    },
    sales_amount: {
      under_1million: '低於1億日圓',
      under_10million: '1億～低於10億日圓',
      under_100million: '10億～低於100億日圓',
      under_1billion: '100億～低於1,000億日圓',
      under_10billion: '1,000億～低於1兆日圓',
      over_10billion: '1兆日圓以上～',
      not_disclose: '不想回答',
    },
    progress: '進度',
    url: {
      contact: 'https://asuene.com/rating/en/form/contact',
      asuene: 'https://asuene.com/apac',
      asuene_lca: '---ja のみ表示---',
      asuene_career: 'https://asuene.com/career/biz',
      corporate: 'https://corp.asuene.com/en',
    },
    head_title: 'ASUENE ESG',
    company_name_inc: 'ASUENE Inc.',
    breakdown: '詳細',
    help: '說明',
    user_display_mode: {
      my_assessment: '自我評估',
      supply_chain_assessment: '供應鏈評估',
    },
    buyer: '委託評估企業',
    supplier: '受評估企業',
    error_page: {
      section_one: '指定的頁面不存在',
      section_two: '請確認連結',
      to_dashboard: '返回數據儀表板',
    },
    priority: {
      good: '良好',
      high: '高',
      medium: '中',
      low: '低',
    },
    priority_full_name: {
      high: '風險高',
      medium: '風險中',
      low: '風險低',
    },
    faq: {
      how_to_use_csv_head: '欲使用Excel開啟下載的CSV檔案時，請依照以下步驟操作。',
      how_to_use_csv_body_01: '1. 開啟新的Excel空白活頁簿。',
      how_to_use_csv_body_02: '2. 在 [資料] 分頁中點擊 [從文字／CSV] 。',
      how_to_use_csv_body_03: '3. 選擇欲開啟的 .csv 檔案後，點擊 [匯入]。',
      how_to_use_csv_body_04: '4. 確認顯示的資料內容是否有問題。',
      how_to_use_csv_body_05: '5. 選擇 [讀入]。',
      how_to_use_csv_note: '※ 步驟可能會依據所使用的OS或Microsoft Excel版本而有所不同。',
    },
    answer_display_status: {
      unanswered: '未回答',
      temporarily_saved: '回覆中',
      submitted: '已回覆',
      score_rated: '完成評估',
      ended: '已結束',
    },
    all: '全部',
    count: {
      // question: '',
      company: ' 公司',
      unit: '筆',
      // number_of_questions_label: '',
    },
    esg_data_display_status: {
      unanswered: '@:common.answer_display_status.unanswered',
      temporarily_saved: '@:common.answer_display_status.temporarily_saved',
      // sharing: '',
      // unshared: '',
      // inviting: '',
      // viewable: '',
      // unviewable: '',
    },
    modal: {
      csv_download_mail_sended: {
        // title: '',
        message_one: '@:list_table_filter.csv_modal_sent_mail_section_one',
        message_two: '@:list_table_filter.csv_modal_sent_mail_section_two',
        message_three: '@:list_table_filter.csv_modal_sent_mail_section_three',
      },
    },
    status: '進度狀況',
    notification: {
      send_back: {
        // title: '',
        // description_1: '',
        // description_2: '',
        comment_label: '@:buyer_scorecard.answer_rejection_modal_text',
      },
      withdraw: {
        // title: '',
        // description_1: '',
        // description_2: '',
        // comment_label: '',
      },
      download: {
        // csv_success_title: '',
        // csv_description_1: '',
        // common_description: '',
        // action: '',
        // csv_failed_title: '',
        // failed_description_1: '',
        // failed_description_2: '',
        // pdf_success_title: '',
        // pdf_description_1: '',
        // pdf_failed_title: '',
      },
      message: {
        // title: '',
        // description: '',
      },
      company_name_label: '@:esg_data.company_name',
      message_label: '@:esg_data.message',
      data_share_invitation: {
        // title: '',
        // description: '',
        // person_label: '',
        data_label: '@:esg_data.data_name',
        // description_1: '',
        // description_2: '',
        // modal_description: '',
      },
      data_share_complete: {
        // title: '',
        // description: '',
      },
      answer_remind: {
        // title: '',
        // description: '',
      },
      // empty_description_1: '',
      // empty_description_2: '',
      // title: '',
      // unread: '',
    },
    buyer_create_question: {
      // title: '',
      // create_survey: '',
      // answer_list: '',
    },
    information: {
      // not_available: '',
      // please_wait: '',
    },
    action: {
      // delete_item: '',
    },
    category_icon: {
      // no_select: '',
      // water: '',
      // waste: '',
      // ghg: '',
      // human_rights: '',
      // occupational_safety: '',
      // security: '',
      // balance_scale: '',
      // icon: '',
      // check: '',
    },
    placeholder: {
      input_free: '請輸入',
      half_digits: '半形數字',
    },
  },
};
